import { useTranslation } from '@klaviyo-mkt/components/hooks/useTranslation';

const languagePrefixes = { 
  'de-DE': 'de',
  'en-AU': 'au',
  'en-GB': 'uk',
  'en-SG': 'sg',
  'en-US': '',
  'es-ES': 'es',
  'fr-FR': 'fr',
  'it-IT': 'it',
};

export const useBreadcrumbs = (path: string, shortTitle?: string, locale?: string) => {
  const { t } = useTranslation();
  const splitPath = path.split('/').filter((slug) => slug != '' && !Object.values(languagePrefixes).includes(slug));

  const capitalize = (s: string) => { 
    if (s === 'ai' || s === 'bfcm') {
      return s.toUpperCase();
    }
    else if (s.includes('bfcm')) {
      const formattedString = !s.startsWith('bfcm') ? s.charAt(0).toUpperCase() + s.slice(1) : s;
      return formattedString.replaceAll('bfcm', 'BFCM');
    }
    else if (s.includes('kbos')) {
      const formattedString = !s.startsWith('kbos') ? s.charAt(0).toUpperCase() + s.slice(1) : s;
      return formattedString.replaceAll('kbos', 'K:BOS');
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const removeDashes = (s: string) => s.split('-').filter((slug) => slug != '').join(' ');
  const homeLink = locale && locale !== 'en-US' ? `/${languagePrefixes[locale as keyof typeof languagePrefixes]}/` : '/';
  const home = [{
    link: homeLink,
    text: t('breadcrumbs_home'),
  }];

  //these are slugs that are not valid pages unless followed by another slug
  const omitCrumbs = ['Product', 'Customers', 'Solutions', 'Case Studies', 'Author', 'Category'];

  let url = `${homeLink.slice(0, -1)}`;
  const crumbs = home.concat(splitPath.map((text: string) => {
    url += `/${text}`;
    const formattedText = removeDashes(capitalize(text));
    return (
      {
        link: url,
        text: formattedText,
      }
    );
  }));
  if (!!shortTitle) {
    crumbs[crumbs.length - 1].text = shortTitle;
  }
  const processedCrumbs = crumbs.filter((s: { link: string; text: string; }) => !(omitCrumbs.includes(s.text)));
  return processedCrumbs;
};

export const useShouldDisplayBreadcrumbs = (path: string, navigationStyle = 'default', showBreadcrumbs = true, locale = '') => {
  const excludePages = ['/', '/uk/', '/uk', '/sg/', '/sg', '/fr/', '/fr', '/au/', '/au', '/sign-up', '/demo-request'];
  const isExcludedDirectory = path.includes('careers/jobs') || path.includes('careers/search-jobs')
    || path.includes('/grow/') || path.includes('/lp/');
  const shouldShowBreadcrumbs = showBreadcrumbs && !excludePages.includes(path)
    && !isExcludedDirectory && navigationStyle !== 'minimal' && ['en-US', 'en-GB', 'en-AU', 'en-SG'].includes(locale);

  return { shouldShowBreadcrumbs, homePrefix: `/${languagePrefixes[locale as keyof typeof languagePrefixes || 'en-US']}${locale && locale !== 'en-US' ? '/' : ''}` };
};
